import { useState } from 'react';
import { arcadeApi, arcadeAuth } from '../../services/arcade';

interface RegisterGateProps {
  onRegistered: () => void;
}

/**
 * Cadastro anônimo do Arcade: só um apelido — sem e-mail, senha ou dados
 * pessoais. O token de acesso fica no navegador do usuário.
 */
export const RegisterGate: React.FC<RegisterGateProps> = ({ onRegistered }) => {
  const [nickname, setNickname] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const submit = async (event: React.FormEvent) => {
    event.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const result = await arcadeApi.register(nickname);
      arcadeAuth.save(result.token, result.nickname);
      onRegistered();
    } catch (err: any) {
      setError(err?.response?.data?.error || 'Falha ao criar perfil. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white rounded-xl shadow p-6 md:p-8 max-w-md mx-auto">
      <h2 className="text-xl font-bold text-gray-900 mb-2">Crie seu perfil para jogar</h2>
      <p className="text-gray-600 text-sm leading-relaxed mb-4">
        Só precisamos de um apelido — sem e-mail, senha ou dados pessoais. Seu acesso fica salvo neste
        navegador; ao limpar os dados do site, o perfil é perdido.
      </p>
      <form onSubmit={submit} className="space-y-3">
        <input
          type="text"
          value={nickname}
          onChange={(e) => setNickname(e.target.value)}
          placeholder="Seu apelido (3-24 caracteres)"
          minLength={3}
          maxLength={24}
          className="w-full border border-gray-300 rounded-lg px-3 py-2.5 text-sm focus:outline-none focus:border-blue-500"
          required
        />
        {error && <p className="text-sm text-red-600">{error}</p>}
        <button
          type="submit"
          disabled={loading}
          className="w-full bg-blue-600 text-white font-semibold rounded-lg px-4 py-2.5 hover:bg-blue-700 transition disabled:opacity-60"
        >
          {loading ? 'Criando...' : 'Começar a jogar'}
        </button>
      </form>
      <p className="text-xs text-gray-400 mt-4 leading-relaxed">
        As NewsCoins (NC) são pontos recreativos internos: não têm valor monetário, não podem ser compradas,
        vendidas, sacadas ou transferidas — e não são uma criptomoeda.
      </p>
    </div>
  );
};
